import React from 'react';

import {skipToken} from '@reduxjs/toolkit/dist/query';

import {useLanesForDocument} from 'app/lanes/api';

export function fetchLanesForDocument<P>(
  WrappedComponent: React.ComponentType<P>,
  content_type:
    | 'procedure'
    | 'procedureversion'
    | 'proceduregroup'
    | 'processversion',
  docIdFetcher: (props: P) => number | string | null
) {
  return function (props) {
    const object_ids = docIdFetcher(props);

    const {refetch} = useLanesForDocument(
      object_ids == null ? skipToken : {object_ids, content_type}
    );

    return <WrappedComponent {...props} refetchLanes={refetch} />;
  };
}
